import { RTKQueryTag } from 'src/common/constants';
import type { ApiResponse, NetworkDiagramData, NetworkDiagramDataPostBody } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';

export const networksApiSLice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNetworkConfigurations: builder.query<ApiResponse<NetworkDiagramData[]>, void>({
      query: () => ({
        url: `/admin/networks/configs`,
        method: 'GET',
      }),
      providesTags: [RTKQueryTag.Networks],
    }),
    saveNetworkConfigurations: builder.mutation<ApiResponse, NetworkDiagramDataPostBody>({
      query: (body) => ({
        url: `/admin/networks/configs`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [RTKQueryTag.Networks],
    }),
  }),
});

export const { useGetNetworkConfigurationsQuery, useSaveNetworkConfigurationsMutation } = networksApiSLice;
